import type { TFunction } from "i18next";
import type { AppDispatch } from "src/common/state/store";
import { setAlert } from "src/features/alert/state/alertsSlice";

/**
 * Dispatch a setAlert with relevant message (color is deduced from httpStatus)
 */
export const displayProperAlert = ({
  httpStatus,
  successMsg,
  errorMsg,
  t,
  dispatch,
}: {
  httpStatus: number | undefined;
  successMsg: string;
  errorMsg: string;
  t: TFunction;
  dispatch: AppDispatch;
}) => {
  const isSuccess = Number(httpStatus) === 200;
  return dispatch(
    setAlert({
      type: isSuccess ? "success" : "danger",
      msg: t(isSuccess ? successMsg : errorMsg),
    }),
  );
};
